var LoadOrderOptionsModel = function (pageModelHndl) {
    var that = this;

    //baseData
    that.ObjectId = ko.observable();
    that.SelectedAmount = ko.observable();
    that.SelectedObjectValues = ko.observableArray([]);
    that.Extensions = ko.observableArray([]);

    //functions
    that.PopulateLoadOrderOptionsModel = function () {
        var mapping = {
            'ignore': ["Attributes"]
        };

        that.ObjectId(pageModelHndl.ObjectId());
        that.SelectedAmount(pageModelHndl.CurrentAmount());

        $.each(pageModelHndl.pProductModel.Attributes(), function (i, attr) {
            if (attr.SelectedObjectValueId() != undefined) {
                that.SelectedObjectValues.push(attr.SelectedObjectValueId());
            }
        });

        $.each(pageModelHndl.pProductModel.Extensions(), function (i, ext) {
            ext.SelectedExtensionObjectValueIds([]);

            $.each(ext.Attributes(), function (i, attr) {
                if (attr.SelectedObjectValueId() != undefined) {
                    ext.SelectedExtensionObjectValueIds.push(attr.SelectedObjectValueId());
                }
            });

            that.Extensions.push(ko.mapping.toJS(ext, mapping));
        });
    };
};